import React from 'react';
// src/App.tsx
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Landing } from './pages/Landing';
import { CreateAgreement } from './pages/CreateAgreement';
import { AgreementCreated } from './pages/AgreementCreated';
import { ClientView } from './pages/ClientView';
import { AgreementDetail } from './pages/AgreementDetail';
import { Dashboard } from './pages/Dashboard';
import { PaymentSuccess } from './pages/PaymentSuccess';
import { MpConnectCallback } from './pages/MpConnectCallback';
import { Legal } from './pages/Legal';
import { Contact } from './pages/Contact';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<Landing data-id="element-3" />} data-id="element-2" />
        <Route path="/create" element={<CreateAgreement data-id="element-5" />} data-id="element-4" />
        <Route path="/agreement-created/:code" element={<AgreementCreated data-id="element-7" />} data-id="element-6" />
        <Route path="/agreement/:code" element={<ClientView data-id="element-9" />} data-id="element-8" />
        <Route path="/agreement/:code/detail" element={<AgreementDetail data-id="element-11" />} data-id="element-10" />
        <Route path="/dashboard" element={<Dashboard data-id="element-13" />} data-id="element-12" />
        <Route path="/payment/success" element={<PaymentSuccess data-id="element-15" />} data-id="element-14" />
        <Route path="/mp/callback" element={<MpConnectCallback data-id="element-17" />} data-id="element-16" />
        <Route path="/legal" element={<Legal data-id="element-19" />} data-id="element-18" />
        <Route path="/contact" element={<Contact data-id="element-21" />} data-id="element-20" />
        <Route path="*" element={<Navigate to="/" replace data-id="element-23" />} data-id="element-22" />
      </Routes>
    </BrowserRouter>;
}